module.exports = __webpack_public_path__ + "img/beijing.5d6f53e7.png";